<template>
    <PlatformTwoColumnLayout invoker="setup" v-bind:sidebarRoutes="settings_sidebar_routes" 
        v-bind:nextRedirectRoute="nextRedirectRoute">
        <template v-slot:sidebar-column="{ sidebarRoutes }">
            <PlatformSidebar :sidebarRoutes="sidebarRoutes">>
                <template v-slot:childroute-only-link="{childRoute, isRouteLink}">
                    <a href="" v-if="!isRouteLink" class="node-link" @click.prevent="addNode(childRoute)">
                    {{ childRoute.name }} <span class="add-btn">+Add</span></a>
                </template>
            </PlatformSidebar>
        </template>
        <template v-slot:content-column>
            <router-view></router-view>
        </template>
    </PlatformTwoColumnLayout>
</template>
<script>
import { mapGetters } from 'vuex';
import PlatformTwoColumnLayout from 'SrcRoot/modules/Common/PlatformTwoColumnLayout';
import PlatformSidebar from 'SrcRoot/modules/Common/Sidebar';
import setupRoutes from 'SrcRoot/modules/Campaign/routes/setup';

export default {
    name: 'CampaignSetupSection',
    components: {
        PlatformTwoColumnLayout,
        PlatformSidebar
    },
    data() {
        const sidebarRoutes = setupRoutes;
        const nextRedirectRoute = {};
        return {
            sidebarRoutes,
            nextRedirectRoute
        };
    },
    computed: {
        ...mapGetters('campaigns', [
            'currentCampaign'
        ]),
        settings_sidebar_routes() {
            if (this.sidebarRoutes === undefined) {
                return [];
            }
            let settings_sidebar_routes = [];
            this.sidebarRoutes.forEach((parent_route) => {
                const parent_route_object = {
                    name: parent_route.meta.sectionName,
                    to: {
                        name: parent_route.name,
                        params: {
                            campaign_id: this.currentCampaign.id
                        }
                    },
                    meta: {
                        isHidden: parent_route.meta.isHidden,
                        isRoute: parent_route.meta.isRoute,
                        fontAwesomeIconName: parent_route.meta.fontAwesomeIconName
                    }
                };

                if (parent_route.children.length) {
                    const { children } = parent_route;
                    let settings_sidebar_child_routes = [];
                    children.forEach((child_route) => {
                        let child_route_object = {
                            name: child_route.meta.sectionName,
                            to: {
                                name: child_route.name,
                                params: {
                                    campaign_id: this.currentCampaign.id
                                }
                            },
                            meta: {
                                isHidden: child_route.meta.isHidden,
                                isRoute: child_route.meta.isRoute,
                                fontAwesomeIconName: child_route.meta.fontAwesomeIconName
                            }
                        };
                        settings_sidebar_child_routes.push(child_route_object);
                    });
                    parent_route_object['children'] = settings_sidebar_child_routes;
                } else {
                    parent_route_object['children'] = [];
                }
                settings_sidebar_routes.push(parent_route_object);
            }); 
            return settings_sidebar_routes;
        }
    }
}
</script>
